import { render, staticRenderFns } from "./addProductList.vue?vue&type=template&id=c77a49e6&scoped=true&"
import script from "./addProductList.vue?vue&type=script&lang=js&"
export * from "./addProductList.vue?vue&type=script&lang=js&"
import style0 from "./addProductList.vue?vue&type=style&index=0&id=c77a49e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77a49e6",
  null
  
)

component.options.__file = "addProductList.vue"
export default component.exports